import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/idp/_layout/settings/')({
  beforeLoad() {
    throw redirect({
      to: '/idp/settings/sso'
    });
  }
});